module.exports = __webpack_public_path__ + "img/comment-active.390256a9.svg";